module.exports = __webpack_public_path__ + "img/ic_logo.0c810f4e.png";